import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, s = /* @__PURE__ */ e("path", {
  fill: "url(#a)",
  d: "m16.609 3.457 3.652 8.192 8.919.942c.573.061.804.772.375 1.158l-6.661 6.004 1.86 8.774a.667.667 0 0 1-.985.716L16 24.76l-7.768 4.481a.667.667 0 0 1-.986-.716l1.86-8.774-6.661-6.003a.667.667 0 0 1 .376-1.158l8.919-.942 3.652-8.192a.666.666 0 0 1 1.217 0"
}, null, -1), l = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("linearGradient", {
    id: "a",
    x1: "6.006",
    x2: "25.395",
    y1: "4.24",
    y2: "30.177",
    gradientUnits: "userSpaceOnUse"
  }, [
    /* @__PURE__ */ e("stop", { "stop-color": "#FFDA1C" }),
    /* @__PURE__ */ e("stop", {
      offset: "1",
      "stop-color": "#FEB705"
    })
  ])
], -1), r = [
  s,
  l
];
function a(c, i) {
  return t(), o("svg", n, [...r]);
}
const p = { render: a };
export {
  p as default,
  a as render
};
